import Highway from '@dogstudio/highway';
import LazyLoad from '../vendor/Lazyload';

import Iframes from '../dom/Iframes';
import CookieConsent from '../dom/CookieConsent';
import Columns from '../dom/Columns';
import Dropdown from '../dom/Dropdown';
import Form from '../dom/Form';
import Filters from '../dom/Filters';
import Anchor from '../dom/Anchor';
import LoadMoreButton from '../dom/LoadMoreButton';
import BodyMovin from '../dom/BodyMovin';
import AutoScroll from '../dom/AutoScroll';
import Sticky from '../dom/Sticky';
import Videos from '../dom/Videos';
import VimeoVideos from '../dom/VimeoVideos';
import Pong from '../pong';

import { copyOnClick } from '../functions';
import ArrowAnimation from '../animation/ArrowAnimation';

export default class PageRenderer extends Highway.Renderer {
  onEnterCompleted() {
    this.bindDOM();

    this.resizeTimeout = null;
    this.bindResize = this.onResize.bind(this);
    window.addEventListener('resize', this.bindResize);

    this.bindFocus = this.onFocus.bind(this);
    window.addEventListener('focus', this.bindFocus);

    this.bindBlur = this.onBlur.bind(this);
    window.addEventListener('blur', this.bindBlur);
  }

  onLeave() {
    window.removeEventListener('resize', this.bindResize);
    window.removeEventListener('focus', this.bindFocus);
    window.removeEventListener('blur', this.bindBlur);

    // this.Parallax.map( obj => obj.unbind() );
    this.BodyMovins.map((obj) => obj.stop());
    this.AutoScrolls.map((obj) => obj.stop());

    this.Videos.stop();
  }

  onResize() {
    // Clears the timeout if it exists
    if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
    // Sets a new timeout
    this.resizeTimeout = setTimeout(this.resize.bind(this), 500);
  }

  onFocus() {
    this.BodyMovins.map((obj) => obj.play());
    this.AutoScrolls.map((obj) => obj.scroll());

    this.Videos.resume();
  }

  onBlur() {
    this.BodyMovins.map((obj) => obj.pause());
    this.AutoScrolls.map((obj) => obj.stop());

    this.Videos.stop();
  }

  bindDOM() {
    this.Lazyloading = new LazyLoad({
      load_delay: 10,
      elements_selector: 'img, .lazy',
      use_native: false,
      callback_loaded: (el) => {
        // add loaded to picture element if exists
        if (el.parentNode) {
          el.parentNode.classList.add('loaded');

          if (el.closest('.project')) {
            el.closest('.project').classList.add('loaded');
          }

          if (el.closest('.link__thumbnail')) {
            el.closest('.link__thumbnail').classList.add('loaded');
            setTimeout(function () {
              el.closest('.link__thumbnail').classList.add('animated');
            }, 1500);
          }

          setTimeout(function () {
            if (el && el.parentNode) el.parentNode.classList.add('animated');
          }, 1500);
        }
      },
    });

    Iframes.setRatio();

    const dropdowns = Array.from(
      document.querySelectorAll('.js-dropdown-trigger')
    );
    this.Dropdowns = dropdowns.map(($el) => new Dropdown($el));

    const anchors = Array.from(document.querySelectorAll('.js-anchor'));
    this.Anchors = anchors.map(($el) => new Anchor($el));

    const toClipboard = Array.from(
      document.querySelectorAll('.js-copy-clipboard')
    );
    toClipboard.map(($el) => copyOnClick($el, $el.dataset.href));

    const forms = Array.from(document.querySelectorAll('.js-form'));
    this.Forms = forms.map(($form) => new Form($form));

    const filters = Array.from(document.querySelectorAll('.js-filters'));
    this.Filters = filters.map(($filters) => new Filters($filters));

    const stickys = Array.from(document.querySelectorAll('.js-sticky'));
    this.Stickys = stickys.map(($sticky) => new Sticky($sticky));

    const loadMoreButtons = Array.from(document.querySelectorAll('.js-load-more'));
    this.LoadMoreButtons = loadMoreButtons.map(($loadMoreButton) => new LoadMoreButton($loadMoreButton));

    const bodymovins = Array.from(document.querySelectorAll('.js-bodymovin'));
    this.BodyMovins = bodymovins.map(($element) => new BodyMovin($element));

    const videos = Array.from(document.querySelectorAll('.js-video'));
    this.Videos = new Videos(videos);

    const arrows = Array.from(document.querySelectorAll('.js-arrow'));
    this.ArrowAnimation = arrows.map(($arrow) => new ArrowAnimation($arrow));

    const autoscrolls = Array.from(document.querySelectorAll('.js-autoscroll'));
    this.AutoScrolls = autoscrolls.map(($element) => new AutoScroll($element));

    const columns = Array.from(document.querySelectorAll('.js-columns'));
    this.Columns = columns.map(($element) => new Columns($element));

    const vimeoVideos = Array.from(document.querySelectorAll('.js-videos'));
    this.VimeoVideos = vimeoVideos.map(($vimeo) => new VimeoVideos($vimeo));

    const pong = Array.from(document.querySelectorAll('.js-pong'));
    this.Pong = pong.map(($header) => new Pong($header));

    const cookieConsents = Array.from(
      document.querySelectorAll('.js-cookie-consent')
    );
    this.CookieConsents = cookieConsents.map(
      ($element) => new CookieConsent($element)
    );

    Iframes.bindImporters();
    Iframes.bindLoadMore();
  }

  resize() {
    Iframes.setRatio();
    this.AutoScrolls.map((obj) => obj.resize());
    this.Columns.map((obj) => obj.resize());
  }
}



// WEBPACK FOOTER //
// ./scripts/navigation/PageRenderer.js